import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Privacy = () => {
  useEffect(() => {
    AOS.refresh();
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  return (
    <>
      <div className="privacy-container">
        <div className="privacy-left">
          <h2 className="privacy-title highlight-gradient">PRIVACY POLICY</h2>
        </div>
        <div className="privacy-right">
          <p className="privacy-text">
            Your privacy is a top priority, and we appreciate the trust you show
            by using our services. This document explains our approach to
            privacy and forms a key part of our website's Terms and Conditions.
            We are dedicated to protecting your personal information and
            tailoring our services to you respectfully. Here, you'll learn how
            we gather your data, the steps we take to keep it safe, and our
            overall privacy practices. Please review this along with our Website
            Terms. We collect personal data from this website and other reliable
            sources to provide our services effectively, manage our relationship
            with you, and make important decisions. This includes understanding
            your financial situation, evaluating credit applications, running
            our business, improving our service, and suggesting suitable
            products or services from us or our trusted partners. We only keep
            the data essential for these purposes and for the period mandated by
            law. We may share your information with other members of our group
            or agents who follow similar privacy protection rules, as the law
            permits. We also sometimes receive information about you from third
            parties, which helps us serve you better. The types of third parties
            we might share your data with include Credit Reference Agencies,
            companies in our corporate family, affiliates, creditors relevant to
            your application, debt collection agencies, tracing agents,
            intermediaries working with us, and entities interested in acquiring
            our company. If required by law (for example, under the Regulation
            of Investigatory Powers Act) or by lawful authorities, we may access
            and share your information. We do this to maintain the integrity of
            our systems and for the protection of our customers and ourselves.
            When you submit an application form on our website, you give us
            permission to contact you by mail, telephone, email, or any other
            communication methods we might adopt. Rest assured, any information
            you give us is stored securely. We also insist that any party we
            share your information with adheres to the same strict
            confidentiality standards.
          </p>
        </div>
      </div>
    </>
  );
};

export default Privacy;
